import {
	toTextFilterParams,
	toTextFilterListArgs,
	toCustomerParams,
	toCustomerListArgs,
} from 'src/admin-app/utilities/list-filtering/mappers';
import { SortCriterion, UserListArgs, UserRegistrationRequestListArgs } from 'src/shared/api';
import {
	toParams,
	fromParamMap,
} from 'src/admin-app/utilities/list-filtering/shared';
import {
	toPagingListArgs,
	toPagingParams,
} from 'src/admin-app/utilities/list-filtering/mappers/to-paging';
import {
	toSortingParams,
	toSortingListArgs,
} from 'src/admin-app/utilities/list-filtering/mappers/to-sort';

export const convertToUsersParams = toParams<UserListArgs>(
	toTextFilterParams,
	toPagingParams,
	toSortingParams,
	toCustomerParams
);

export const convertToUsersListArgs = fromParamMap<UserListArgs>(
	toTextFilterListArgs,
	toPagingListArgs,
	toSortingListArgs,
	toCustomerListArgs
);

export const convertToRegistrationRequestListArgs = fromParamMap<UserRegistrationRequestListArgs>(
	toTextFilterListArgs,
	toPagingListArgs,
	toSortingListArgs
);

export type CustomerUserListFilters = Omit<
	UserListArgs,
	keyof {
		sortCriteria?: SortCriterion[];
		pageSize: number;
		pageNumber: number;
	}
>;
